import { APIFetch, RequestHeaders } from "@certa/network";
import { queryClient } from "../utils/utils";
import { USER_TIMEZONE_QUERY_KEY } from "../constants/auth.constants";

const handleUpdateUserTimezone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({ timezone })
  };

  return APIFetch("users/set_user_timezone/", requestOptions);
};

const isTimezoneInSession = () => {
  const timezoneInSession = queryClient.getQueryData(USER_TIMEZONE_QUERY_KEY);
  return !!timezoneInSession;
};

const setTimezoneInSession = async (): Promise<void> => {
  if (isTimezoneInSession()) return;
  try {
    // optimistic update to prevent more calls
    queryClient.setQueryData(USER_TIMEZONE_QUERY_KEY, true);
    await handleUpdateUserTimezone();
  } catch (error) {
    queryClient.setQueryData(USER_TIMEZONE_QUERY_KEY, false);
    console.warn("Failed to set user timezone:", error);
    throw error;
  }
};

export const setUserTimezoneService = {
  handleUpdateUserTimezone,
  isTimezoneInSession,
  setTimezoneInSession
};
